(function () {
    'use strict';

    function setupMobileMenu() {
        const mobileMenuButton = document.getElementById("mobile-menu-button");
        const closeMenuButton = document.getElementById("close-menu-button");
        const mobileMenu = document.getElementById("mobile-menu");

        function toggleMobileMenu() {
            mobileMenu.classList.toggle("translate-x-full");
            mobileMenu.classList.toggle("translate-x-0");
        }

        if (mobileMenuButton) mobileMenuButton.addEventListener("click", toggleMobileMenu);
        if (closeMenuButton) closeMenuButton.addEventListener("click", toggleMobileMenu);
    }

    function setupAccordionSections() {
        const cards = document.querySelectorAll("[data-accordion-section]");
        if (!cards.length) {
            return { openSection: () => {} };
        }

        const cardMap = new Map();
        cards.forEach(card => {
            const id = card.dataset.accordionSection;
            if (id) {
                cardMap.set(id, card);
            }
        });

        const dispatchChange = (sectionId, isOpen) => {
            document.dispatchEvent(new CustomEvent("accordion:change", {
                detail: { sectionId, isOpen }
            }));
        };

        const closeCard = (card) => {
            if (!card) return;
            card.classList.remove("is-open");
            const trigger = card.querySelector("[data-accordion-trigger]");
            if (trigger) {
                trigger.setAttribute("aria-expanded", "false");
            }
        };

        const openSection = (sectionId, options = {}) => {
            const card = cardMap.get(sectionId);
            if (!card) return;
            cards.forEach(otherCard => {
                if (otherCard === card) {
                    otherCard.classList.add("is-open");
                    const trigger = otherCard.querySelector("[data-accordion-trigger]");
                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "true");
                    }
                } else {
                    closeCard(otherCard);
                }
            });
            if (options.scrollIntoView) {
                card.scrollIntoView({ behavior: "smooth", block: "start" });
            }
            dispatchChange(sectionId, true);
        };

        const toggleSection = (sectionId) => {
            const card = cardMap.get(sectionId);
            if (!card) return;
            const isOpen = card.classList.contains("is-open");
            if (isOpen) {
                closeCard(card);
                dispatchChange(sectionId, false);
            } else {
                openSection(sectionId);
            }
        };

        cardMap.forEach((card, sectionId) => {
            const trigger = card.querySelector("[data-accordion-trigger]");
            if (trigger) {
                trigger.addEventListener("click", () => toggleSection(sectionId));
            }
        });

        const shortcutsEl = document.getElementById("filter-shortcuts");
        let defaultSection = shortcutsEl && shortcutsEl.dataset.defaultShortcut;
        if (!defaultSection || !cardMap.has(defaultSection)) {
            defaultSection = cards[0] && cards[0].dataset.accordionSection;
        }
        if (defaultSection) {
            openSection(defaultSection);
        }

        return { openSection, toggleSection };
    }

    function setupFilterShortcuts(accordionController) {
        const shortcutLinks = document.querySelectorAll("[data-filter-shortcut]");
        if (!shortcutLinks.length) {
            return;
        }

        const uniqueSections = Array.from(new Set(Array.from(shortcutLinks).map(link => link.dataset.filterShortcut)))
            .map(id => document.getElementById(id))
            .filter(Boolean);

        const setActive = (sectionId) => {
            shortcutLinks.forEach(link => {
                const isActive = link.dataset.filterShortcut === sectionId;
                link.classList.toggle("is-active", isActive);
                link.setAttribute("aria-current", isActive ? "true" : "false");
            });
        };

        const shortcutsWrapper = document.getElementById("filter-shortcuts");
        if (shortcutsWrapper && shortcutsWrapper.dataset.defaultShortcut) {
            setActive(shortcutsWrapper.dataset.defaultShortcut);
        }

        shortcutLinks.forEach(link => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                const targetId = link.dataset.filterShortcut;
                if (accordionController.openSection) {
                    accordionController.openSection(targetId, { scrollIntoView: true });
                }
                setActive(targetId);
            });
        });

        document.addEventListener("accordion:change", (event) => {
            if (event.detail && event.detail.isOpen) {
                setActive(event.detail.sectionId);
            }
        });

        if (uniqueSections.length && "IntersectionObserver" in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.target.classList.contains("is-open")) {
                        setActive(entry.target.id);
                    }
                });
            }, { rootMargin: "-40% 0px -50% 0px" });

            uniqueSections.forEach(section => observer.observe(section));
        }
    }

    function setupCollapsibleLists() {
        const lists = document.querySelectorAll("[data-collapsible-list]");
        if (!lists.length) {
            return;
        }

        const state = new Map();

        const applyState = (entry) => {
            const { list, defaultVisible, expanded } = entry;
            const items = list.querySelectorAll("[data-collapsible-item]");
            items.forEach((item, index) => {
                const shouldHide = !expanded && index >= defaultVisible;
                item.classList.toggle("is-hidden", shouldHide);
            });
        };

        lists.forEach(list => {
            const defaultVisible = parseInt(list.dataset.defaultVisible || "9999", 10);
            const sectionId = list.dataset.section;
            if (!sectionId) return;
            const entry = { list, defaultVisible, expanded: false };
            state.set(sectionId, entry);
            applyState(entry);
        });

        const toggles = document.querySelectorAll("[data-collapsible-toggle]");
        toggles.forEach(toggle => {
            const target = toggle.dataset.target;
            const entry = state.get(target);
            if (!entry) return;

            const updateLabel = () => {
                const label = toggle.dataset.toggleLabel || "items";
                toggle.textContent = entry.expanded ? `Show fewer ${label}` : `Show all ${label}`;
                toggle.setAttribute("aria-expanded", entry.expanded ? "true" : "false");
            };

            toggle.addEventListener("click", () => {
                entry.expanded = !entry.expanded;
                applyState(entry);
                updateLabel();
            });

            updateLabel();
        });
    }

    function setupMakeDirectory() {
        const searchInput = document.querySelector("[data-make-search]");
        const list = document.querySelector("[data-makes-list]");
        if (!list) return;

        const items = Array.from(list.querySelectorAll("[data-filter-text]"));
        const emptyState = document.querySelector("[data-make-empty]");

        const filterItems = (term) => {
            const query = term.trim().toLowerCase();
            let visibleCount = 0;
            items.forEach(item => {
                const match = !query || (item.dataset.filterText || "").includes(query);
                item.classList.toggle("is-hidden", !match);
                if (match) visibleCount++;
            });
            if (emptyState) {
                emptyState.hidden = visibleCount !== 0;
            }
        };

        if (searchInput) {
            searchInput.addEventListener("input", (event) => {
                filterItems(event.target.value);
            });
        }

        filterItems("");
        setupLetterNav();
    }

    function setupLetterNav() {
        const nav = document.querySelector("[data-letter-nav]");
        const anchors = document.querySelectorAll("[data-letter-anchor]");
        if (!nav || !anchors.length) {
            if (nav) {
                nav.hidden = true;
            }
            return;
        }

        nav.hidden = false;
        nav.innerHTML = "";
        const buttons = [];

        const setActiveLetter = (letter) => {
            buttons.forEach(btn => {
                const isActive = btn.dataset.letter === letter;
                btn.classList.toggle("active", isActive);
            });
        };

        anchors.forEach(anchor => {
            const letter = anchor.dataset.letter || anchor.textContent.trim().charAt(0).toUpperCase();
            const button = document.createElement("button");
            button.type = "button";
            button.className = "letter-chip";
            button.dataset.letter = letter;
            button.textContent = letter;
            button.addEventListener("click", () => {
                anchor.scrollIntoView({ behavior: "smooth", block: "start" });
                setActiveLetter(letter);
            });
            buttons.push(button);
            nav.appendChild(button);
        });

        const firstLetter = buttons[0] ? buttons[0].dataset.letter : "";
        setActiveLetter(firstLetter || "");
    }

    document.addEventListener("DOMContentLoaded", () => {
        setupMobileMenu();
        const accordionController = setupAccordionSections();
        setupFilterShortcuts(accordionController);
        setupCollapsibleLists();
        setupMakeDirectory();
    });

}());
